import React from 'react'
import { HeroSection } from '../../components/KitsHeroSection'
import { Section } from '../../components/KitsSection'
import {sections, hero_section, display_items} from './data'
import {PageWrapper, SectionSeperator} from '../../components/KitsSection/style'
import { DisplayRow } from '../../components/DisplayRow'
import { ContactUsRow } from '../../components/ContactUsRow'



export const Homepage = () =>  {
    const Sections = sections.map((section) => {
        return(<Section key={section.id} section={section}/>)
    })
    return (
        <>
        <PageWrapper>
            <HeroSection section={hero_section} />
            <DisplayRow data={display_items}/>
            <SectionSeperator/>
            {Sections}
            <ContactUsRow/>
        </PageWrapper>
        </>
    )
}
